import * as React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types'
import TextField from "@mui/material/TextField";
import {Divider, useTheme} from "@mui/material";
import ShareRoundedIcon from '@mui/icons-material/ShareRounded';
import {toast} from "react-toastify";
import {FastfoodRounded} from "@mui/icons-material";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: 400,
    width: '80vw',
    bgcolor: 'background.paper',
    p: 4,
    borderRadius: '15px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column'
};

export default function EditMenuModal(
    {open, setOpen, actionIfYes, actionIfNo, title, description, yesBtnText, closeBtnText, content}) {
    const theme = useTheme();
    const [value, setValue] = React.useState('');

    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={open}
            onClose={()=>setOpen(false)}
            closeAfterTransition
        >
                <Box sx={style}>
                    <Box sx={{width: '100%', mt: 2}}>
                        {content}
                    </Box>
                </Box>
        </Modal>
    );
}

EditMenuModal.propTypes = {
    actionIfYes: PropTypes.any,
    open: PropTypes.any,
    setOpen: PropTypes.any
}
